class DcbCartSteps extends HTMLElement {
  connectedCallback() {
    // The section script can run before this element's children are parsed,
    // which would leave every querySelector null and no listeners attached.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    this.querySelectorAll('[data-step-next]').forEach((btn) => {
      btn.addEventListener('click', () => this.goTo(btn.getAttribute('data-step-next')));
    });
    const form = this.querySelector('[data-details-form]');
    if (form) form.addEventListener('submit', (e) => this.submitDetails(e));

    this.querySelectorAll('[data-cart-qty]').forEach((el) => {
      const line = el.getAttribute('data-line');
      const dec = el.querySelector('[data-qty-dec]');
      const inc = el.querySelector('[data-qty-inc]');
      const val = el.querySelector('.dcb-cart-item__qty-val');
      if (dec) dec.addEventListener('click', () => this.changeQty(line, Math.max(1, parseInt(val.textContent, 10) - 1)));
      if (inc) inc.addEventListener('click', () => this.changeQty(line, parseInt(val.textContent, 10) + 1));
    });
    this.querySelectorAll('[data-cart-remove]').forEach((btn) => {
      btn.addEventListener('click', () => this.changeQty(btn.getAttribute('data-line'), 0));
    });
  }

  goTo(step) {
    this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = el.getAttribute('data-step') !== step; });
    const root = this.closest('.dcb-cartpage');
    if (root) {
      root.querySelectorAll('[data-step-indicator]').forEach((el) => {
        el.classList.toggle('is-active', el.getAttribute('data-step-indicator') === step);
      });
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  changeQty(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity }),
    })
      .then((r) => r.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('dcb:cart-updated', { detail: { item_count: cart.item_count } }));
        window.location.reload();
      });
  }

  submitDetails(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const attributes = {};
    ['voornaam', 'achternaam', 'email', 'telefoon', 'adres', 'postcode', 'plaats', 'bedrijf'].forEach((key) => {
      attributes[key] = data.get(key) || '';
    });
    attributes['akkoord_geen_herroepingsrecht'] = data.get('akkoord') ? 'ja' : 'nee';
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
    })
      .then(() => { window.location.href = '/checkout'; })
      .catch(() => { if (submitBtn) submitBtn.disabled = false; });
  }
}
customElements.define('dcb-cart-steps', DcbCartSteps);
